
import { defineComponent, onMounted, reactive, toRefs } from "vue";

type TStyle = { left: string; top: string }[];
export default defineComponent({
  name: "CSsDefault",
  setup(props, ctx) {
    console.log(props, ctx);
    onMounted(() => {
      console.log("view95 按钮涟漪特效");
    });

    const data = reactive<{ spanList1: TStyle; spanList2: TStyle }>({
      spanList1: [],
      spanList2: []
    });

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const x = e.clientX - target.offsetLeft;
      const y = e.clientY - target.offsetTop;
      const list = target.dataset.id === "1" ? data.spanList1 : data.spanList2;
      // if (list.length >= 3) {
      //   list.shift();
      // }
      list.push({ left: x + "px", top: y + "px" });
      setTimeout(() => {
        list.shift();
      }, 500);
    };

    return {
      ...toRefs(data),
      handleClick
    };
  }
});
